var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EB0029"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9142 8.29724C17.9209 8.73019 21.0402 12.1236 21.0402 16.2455V19.0765H18.4347V16.2455C18.4347 13.5651 16.4773 11.3415 13.9142 10.9261V19.0765H12.1769V10.9261C9.61377 11.3415 7.65637 13.5651 7.65637 16.2455V19.0765H5.0509V16.2455C5.05091 12.1236 8.17011 8.73018 12.1769 8.29724V5.1781H13.9142V8.29724Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzn);
export default __webpack_public_path__ + "static/media/azn.5f5ae4f2722f2bd698c23fd488f1d4a9.svg";
export { ForwardRef as ReactComponent };